import { alpha } from '@mui/material/styles';
import { makeStyles } from 'tss-react/mui';

const styles = makeStyles()((theme) => ({
  imageUploadsDisclaimer: {
    paddingTop: theme.spacing(2),
  },
  errorText: {
    color: theme.palette.error.main,
  },
  imageContainer: {
    paddingTop: theme.spacing(1),
    width: '100%',
  },
  imageContainerMultiple: {
    paddingTop: theme.spacing(1),
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  fileName: {
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(1),
  },
  uploadButton: {
    maxHeight: '30px',
    borderRadius: '2.5px !important',
  },
  iconButton: {
    color: theme.palette.common.white,
    position: 'absolute',
    bottom: theme.spacing(1),
    right: theme.spacing(1),
    zIndex: 2,
    backgroundColor: alpha(theme.palette.common.black, 0.54),
    '&:hover': {
      backgroundColor: alpha(theme.palette.common.black, 0.65),
    },
  },
  /** Banner variant: upload control bottom-right of the banner area (e.g. edit profile hero). */
  bannerUploadIconBottomRight: {
    left: 'auto',
    top: 'auto',
    bottom: theme.spacing(3),
    right: theme.spacing(3),
    transform: 'none',
  },
  removeButton: {
    color: theme.palette.common.white,
    position: 'absolute',
    zIndex: 2,
    backgroundColor: alpha(theme.palette.common.black, 0.54),
    '&:hover': {
      backgroundColor: alpha(theme.palette.common.black, 0.65),
    },
  },
  removeButtonBanner: {
    top: 'auto',
    left: 'auto',
    bottom: theme.spacing(6),
    right: theme.spacing(1),
  },
  removeButtonAvatar: {
    top: theme.spacing(1),
    left: theme.spacing(1),
    bottom: 'auto',
    right: 'auto',
  },
  imageContainerButtonLeft: {
    position: 'relative',
    width: '100%',
  },
  removeImage: {
    position: 'absolute',
    top: '9px',
    right: '1px',
    zIndex: 10,
  },
  bannerContainer: {
    height: '350px',
    width: '100%',
    [theme.breakpoints.down('md')]: {
      height: '300px',
    },
    position: 'relative',
    overflow: 'hidden',
  },
  gradientFade: {
    height: '100%',
    width: '100%',
    zIndex: 1,
    background: 'linear-gradient(0deg, rgba(0,0,0,0.6) 05%, rgba(0,0,0,0) 100%)',
  },
  banner: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  avatar: {
    width: '100%',
    height: '100%',
    borderRadius: '4%',
    backgroundColor: theme.palette.primary.light,
    fontSize: theme.typography.pxToRem(40),
  },
  avatarContainer: {
    position: 'relative',
    height: '150px',
    width: '150px',
  },
  avatarGradient: {
    borderRadius: '4%',
  },
  multiSelectImageContainer: {
    margin: '8px',
    width: 'auto',
    maxWidth: '40%',
    height: 'auto',
    maxHeight: '20vh',
    boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
  },
  imageInput: {
    display: 'none',
  },
  uploadLabel: {
    display: 'inline-block',
    width: '100%',
    cursor: 'pointer',
  },
}));

export default styles;
